<h2 mat-dialog-title>{{ data.title }}</h2>
<div mat-dialog-content>
  <p>{{ data.message }}</p>
  <mat-form-field appearance="outline" style="width: 100%;">
    <input matInput [placeholder]="data.placeholder" [formControl]="inputControl" autofocus>
    <mat-error *ngIf="inputControl.invalid">This field is required</mat-error>
  </mat-form-field>
</div>
<div mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">{{ data.cancelBtnTxt }}</button>
  <button mat-raised-button color="primary" (click)="onConfirm()" [disabled]="inputControl.invalid">{{ data.okBtnTxt }}</button>
</div>